@if (!editMode) {
  <div class="form-group row">
    @for (slide of rowData?.slides?.slides; track slide) {
      <div class="slides-adjust">
        <app-display-hero-slide
          [html]="slide.html"
          [css]="slide.css"
          [slideId]="slide.id"
          [name]="slide.name"></app-display-hero-slide>
      </div>
    }
  </div>
}
@if (editMode) {
  <div class="form-group row">
    <!-- <app-nested-table-form-field></app-nested-table-form-field> -->
    <p>So how are we going to do this?</p>
  </div>
}
